<template>
  <div class="MediaMenu">
    <ButtonUpload/>
    <div class="MediaMenu__actions">
      <div
      v-if="canDownload"
      class="MediaMenu__action"
      @click="downloadSelectedFiles">
        <SvgImage
        imageName="FileDownload"
        class="MediaMenu__action-icon"/>
        <span class="MediaMenu__action-title">
          Download
        </span>
      </div>
      <div
      v-if="checkedFiles.length"
      class="MediaMenu__action"
      @click="multipleFilesDelete(checkedFiles)">
        <SvgImage
        imageName="FileDelete"
        class="MediaMenu__action-icon"/>
        <span class="MediaMenu__action-title MediaMenu__action-title--red">
          Delete
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ButtonUpload from '@/components/common/ButtonUpload'

import FileDeleteMixin from '@/components/mixins/FileDelete.mixin'

export default {
  name: 'MediaMenu',

  components: {
    ButtonUpload
  },

  mixins: [
    FileDeleteMixin
  ],

  computed: {
    ...mapGetters('select', [
      'checkedFiles'
    ]),
    canDownload () {
      if (!this.checkedFiles.length) return false
      const index = this.checkedFiles.findIndex(f => {
        return f.type === 5
      })
      return index === -1
    }
  },

  methods: {
    ...mapActions('filesTransfer', [
      'pushFileDownload'
    ]),
    downloadSelectedFiles () {
      this.checkedFiles.forEach(f => {
        this.pushFileDownload(f)
      })
    }
  }
}
</script>

<style lang="scss">
@import 'MediaMenu';
</style>
